// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const TipGold = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Group 1010105284">
        <path
          id="Vector"
          d="M8.4458 16.8903V1.99988M1.875 1.125H15"
          stroke="url(#paint0_linear_10256_40054)"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10256_40054"
          x1="8.4375"
          y1="1.125"
          x2="8.4375"
          y2="16.8903"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
